<template>
  <!-- Destination × Theme ページ候補（/{destination}/{theme}）。feature(categoryLabel=destination-theme) を Theme 特集カード行と同じ FeatureRow で表示（JCAT-5557） -->
  <FeatureRow :category-label="categoryLabel" :on-click="props.onClick" :thumbnail-url="hit.feature.thumbnailUrl" :title="hit.feature.title" :to="path" />
</template>

<script setup lang="ts">
import FeatureRow from '@/wabunka-src/features/Search/components/model/FeatureRow.vue';
import { buildDestinationThemeCategoryLabel, type AlgoliaFeatureHit } from '@/wabunka-src/features/Search/models/algoliaHit';
import { buildDestinationThemePath } from '@/wabunka-src/features/Search/models/algoliaHitLink';

interface Props {
  hit: AlgoliaFeatureHit;
  // destination の slug → タグ名の索引（buildDestinationNameBySlug の結果）。チップに実タグ名を出すために使う。
  destinationNameBySlug: ReadonlyMap<string, string>;
  onClick?: () => void;
}

const props = defineProps<Props>();

const path = computed(() => buildDestinationThemePath(props.hit));

// カテゴリラベルのチップには destination 名を出す（表示値の組み立ては models のビルダーへ委譲）。
const categoryLabel = computed(() => buildDestinationThemeCategoryLabel(props.hit, props.destinationNameBySlug));
</script>
